export { useYardTaskByRelatedEntityFetcher } from './useYardTaskByRelatedEntityFetcher';
export type {
  UseYardTaskByRelatedEntityFetcherOptions,
  UseYardTaskByRelatedEntityFetcherOptions as UseYardTaskByRelatedEntityPresenterOptions
} from './useYardTaskByRelatedEntityFetcher';

import { useYardTaskByRelatedEntityFetcher } from './useYardTaskByRelatedEntityFetcher';

import type { UseYardTaskByRelatedEntityFetcherOptions } from './useYardTaskByRelatedEntityFetcher';

/**
 * Combined fetch + live-update composable. Delegates to {@link useYardTaskByRelatedEntityFetcher}.
 */
export function useYardTaskByRelatedEntityPresenter(
  options: UseYardTaskByRelatedEntityFetcherOptions
) {
  return useYardTaskByRelatedEntityFetcher(options);
}
